module.exports = __webpack_public_path__ + "static/cogicon-f88a81ca99505c90710744186165086e.png";